"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FIELD_CONSTANTS = require("./mappings/FIELD_CONSTANTS");

var _Patterns = _interopRequireDefault(require("./Patterns"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var legacyFieldValueMap = (0, _FIELD_CONSTANTS.FIELD_VALUE_MAP)('legacy');
var oneMktoFieldValueMap = (0, _FIELD_CONSTANTS.FIELD_VALUE_MAP)('oneMkto');
var legacy = {
  "AnnualSales": {
    "type": "string",
    "maxLength": 20
  },
  "company": {
    "type": "string",
    "maxLength": 80
  },
  "Address2": {
    "type": "string",
    "maxLength": 40
  },
  "Address3": {
    "type": "string",
    "maxLength": 40
  },
  "city": {
    "type": "string",
    "maxLength": 40
  },
  "ClienteleTitle": {
    "type": "string",
    "maxLength": 60
  },
  "firstName": {
    "type": "string",
    "maxLength": 40
  },
  "lastName": {
    "type": "string",
    "maxLength": 80
  },
  "LocalCity": {
    "type": "string",
    "maxLength": 80
  },
  "LocalCountry": {
    "type": "string",
    "maxLength": 80
  },
  "LocalAccount": {
    "type": "string",
    "maxLength": 80
  },
  "LocalFirstName": {
    "type": "string",
    "maxLength": 40
  },
  "LocalLastName": {
    "type": "string",
    "maxLength": 80
  },
  "LocalPostalCode": {
    "type": "string",
    "maxLength": 10
  },
  "LocalState/Province": {
    "type": "string",
    "maxLength": 20
  },
  "LocalStreetAddressLine1": {
    "type": "string",
    "maxLength": 40
  },
  "LocalStreetAddressLine2": {
    "type": "string",
    "maxLength": 40
  },
  "LocalStreetAddressLine3": {
    "type": "string",
    "maxLength": 40
  },
  "ProspectType": {
    "type": "string",
    "maxLength": 40
  },
  "street": {
    "type": "string",
    "maxLength": 40
  },
  "state": {
    "type": "string",
    "maxLength": 64
  },
  "Answer1": {
    "type": "string",
    "maxLength": 255
  },
  "Answer2": {
    "type": "string",
    "maxLength": 255
  },
  "Answer3": {
    "type": "string",
    "maxLength": 255
  },
  "Answer4": {
    "type": "string",
    "maxLength": 255
  },
  "Answer5": {
    "type": "string",
    "maxLength": 255
  },
  "Comments": {
    "type": "string",
    "maxLength": 2000
  },
  "Comments6": {
    "type": "string",
    "maxLength": 2000
  },
  "Comments7": {
    "type": "string",
    "maxLength": 2000
  },
  "Question1": {
    "type": "string",
    "maxLength": 255
  },
  "Question2": {
    "type": "string",
    "maxLength": 255
  },
  "Question3": {
    "type": "string",
    "maxLength": 255
  },
  "Question4": {
    "type": "string",
    "maxLength": 255
  },
  "Question5": {
    "type": "string",
    "maxLength": 255
  },
  "NumberofDesktops": {
    "type": "string",
    "maxLength": 40
  },
  "NumberofServersGlobal": {
    "type": "string",
    "maxLength": 40
  },
  "UTMCampaign": {
    "type": "string",
    "maxLength": 80
  },
  "UTMContent": {
    "type": "string",
    "maxLength": 80
  },
  "UTMDomain": {
    "type": "string",
    "maxLength": 80
  },
  "UTMMasterCode": {
    "type": "string",
    "maxLength": 80
  },
  "UTMProgramCode": {
    "type": "string",
    "maxLength": 80
  },
  "UTMSource": {
    "type": "string",
    "maxLength": 80
  },
  "UTMTerm": {
    "type": "string",
    "maxLength": 80
  },
  "postalCode": {
    "type": "string",
    "maxLength": 10
  },
  // "country": {
  //     "type": "string",
  //     "enum": legacyFieldValueMap.country,
  //     "error": "'${/country}' is not a valid 'country'."
  // },
  "Department": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.Department)),
    "error": "'${/Department}' is not a valid 'Department'."
  },
  "industry": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.industry)),
    "error": "'${/industry}' is not a valid 'industry'."
  },
  "NumberofEmployees-Global": {
    "type": "string",
    "pattern": _Patterns.default.NUMBER_OF_EMPLOYEES_GLOBAL,
    "error": "${/NumberofEmployees-Global} is not a valid 'NumberofEmployees-Global'."
  },
  "NumberofEmployees-here/atlocation": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap["NumberofEmployees-here/atlocation"])),
    "error": "The value passed for 'NumberofEmployees-here/atlocation' is invalid."
  },
  "salutation": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.salutation)),
    "error": "'${/salutation}' is not a valid 'salutation'."
  },
  "title": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.title)),
    "error": "'${/title}' is not a valid 'title'."
  },
  "Challenge": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.Challenge)),
    "error": "'${/Challenge}' is not a valid 'Challenge'."
  },
  "IfProjectdoyouhaveBudget": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.IfProjectdoyouhaveBudget)),
    "error": "'${/IfProjectdoyouhaveBudget}' is not a valid 'PurchaseTimeframe'."
  },
  "PurchaseTimeframe": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.PurchaseTimeframe)),
    "error": "'${/PurchaseTimeframe}' is not a valid 'PurchaseTimeframe'."
  },
  "VirtualizationInitiative": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.VirtualizationInitiative)),
    "error": "'VirtualizationInitiative' must be 'Yes' or 'No'."
  },
  "MailOK": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.MailOk))
  },
  "EmailOK": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.MailOk)),
    "error": "'EmailOK' must be 'Yes' or 'No'."
  },
  "PhoneOK": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.PhoneOk)),
    "error": "'PhoneOK' must be 'Yes' or 'No'."
  },
  "PreferredLanguage": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.PreferredLanguage)),
    "error": "'${/PreferredLanguage}' is not a valid 'PreferredLanguage'."
  },
  "Hot_HaveSalesCallME": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.Hot_HaveSalesCallME)),
    "error": "'Hot_HaveSalesCallME' must be 'Yes' or 'No'."
  },
  "ctx_RecordProcessingType": {
    "type": "string",
    "enum": legacyFieldValueMap.ctx_RecordProcessingType,
    "error": "'${/ctx_RecordProcessingType}' is not a valid 'ctx_RecordProcessingType'."
  },
  "NumberofServersProject": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.NumberofServersProject)),
    "error": "'${/NumberofServersProject}' is not a valid 'NumberofServersProject'."
  },
  "GEORegionSource": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(legacyFieldValueMap.GEORegionSource)),
    "error": "'${/GEORegionSource}' is not a valid 'GEORegionSource'."
  },
  "reason": {
    "type": "string",
    "error": "'reason' must be 'Manual Import or Remote POST'.",
    "enum": ["Manual Import or Remote POST"]
  },
  "lookupField": {
    "type": "string",
    "error": "'lookupField' must be 'email'.",
    "enum": ["email"]
  },
  "InteractionStage": {
    "type": "string",
    "enum": ["1", "2"],
    "error": "'InteractionStage' must be 1 or 2."
  },
  "leadStatus": {
    "type": "string",
    "enum": ["A", "B", "I"],
    "error": "'leadStatus' must be 'A', 'B' or 'I'."
  },
  "source": {
    "type": "string",
    "pattern": _Patterns.default.SOURCE,
    "error": "'source' should follow this pattern 'MarTel Slug: [slug]'"
  },
  "partnerid": {
    "type": "string",
    "pattern": "^\\s*$",
    "error": "'partnerid' should not be present for this type ${/ctx_RecordProcessingType}."
  },
  "RegistrationDate": {
    "type": "string",
    "pattern": _Patterns.default.DATE,
    "error": "RegistrationDate is either in not in YYYY-mm-dd format, or older than 2010"
  },
  "GEOContactEmail": {
    "type": "string",
    "pattern": _Patterns.default.EMAIL,
    "error": "GeoContantEmail ${/GeoContantEmail} does not appear to be a valid email address."
  },
  "email": {
    "type": "string",
    "pattern": _Patterns.default.EMAIL,
    "error": "${/email} does not appear to be a valid email address."
  },
  "programName": {
    "type": "string",
    "pattern": _Patterns.default.LEGACY_PROGRAM_NAME,
    "error": "'programName' must less than 80 characters and end with '_MKTO'."
  },
  "mainPhone": {
    "type": "string",
    "pattern": _Patterns.default.PHONE,
    "error": "'mainPhone' does not appear to be a valid phone format ${/mainPhone}."
  },
  "mobilePhone": {
    "type": "string",
    "pattern": _Patterns.default.PHONE,
    "error": "'mobilePhone' does not appear to be a valid phone format ${/mobilePhone}."
  },
  "Citrix_SFDC_Account_ID": {
    "type": "string",
    "maxLength": 40
  },
  "Citrix_SFDC_Contact_ID": {
    "type": "string",
    "maxLength": 40
  },
  "UTMCampaignNum": {
    "type": "string",
    "maxLength": 255
  },
  "UTMChannel": {
    "type": "string",
    "maxLength": 255
  },
  "UTMLastCampaignSession": {
    "type": "string",
    "maxLength": 255
  },
  "UTMReferralSources": {
    "type": "string",
    "maxLength": 255
  },
  "UTMSessionCount": {
    "type": "string",
    "maxLength": 255
  },
  "UTMSessionDate": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_annual_sales": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_city": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_company": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_company_domestic_hq": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_company_hq": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_company_world_hq": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_country_code": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_country_name": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_datasource": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_domain_match": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_duns_number": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_duns_number_domestic_hq": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_duns_number_hq": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_duns_number_world_hq": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_employee_count": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_employee_range": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_enhanced": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_id": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_information_level": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_ip_address": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_marketing_alias": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_phone": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_prefilled": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_primary_industry": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_primary_sic": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_primary_source": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_state": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_street_address": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_sub_industry": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_url": {
    "type": "string",
    "maxLength": 255
  },
  "dbase_zip": {
    "type": "string",
    "maxLength": 255
  },
  "marketingSuspended": {
    "type": "string",
    "pattern": _Patterns.default.TRUE_OR_FALSE,
    "error": "${/marketingSuspended} is not a valid 'marketingSuspended'."
  }
};
var oneMkto = {
  "Answer_1__c": {
    "type": "string",
    "maxLength": 255
  },
  "Answer_2__c": {
    "type": "string",
    "maxLength": 255
  },
  "Answer_3__c": {
    "type": "string",
    "maxLength": 255
  },
  "Answer_4__c": {
    "type": "string",
    "maxLength": 255
  },
  "Answer_5__c": {
    "type": "string",
    "maxLength": 255
  },
  "Challenge__c": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(oneMktoFieldValueMap.Challenge__c)),
    "error": "'${/Challenge__c}' is not a valid 'Challenge__c'."
  },
  "Citrix_SFDC_Account_ID": {
    "type": "string",
    "maxLength": 18
  },
  "Citrix_SFDC_Contact_ID": {
    "type": "string",
    "maxLength": 18
  },
  "Comments_6__c": {
    "type": "string",
    "maxLength": 2000
  },
  "Comments_7__c": {
    "type": "string",
    "maxLength": 2000
  },
  "Comments__c": {
    "type": "string",
    "maxLength": 2000
  },
  "Company_Self_Reported__c": {
    "type": "string",
    "maxLength": 80
  },
  "Demandase_Id__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Annual_Sales__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_City__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Company_Domestic_HQ__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Company_HQ__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Company_Name__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Company_World_HQ__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Country_Code__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Country__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Datasource__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Domain_Match__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Employee_Count__c": {
    // TODO TYPE: Integer
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Employee_Range__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Enhanced__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Id__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_IP__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Industry__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Information_Level__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Marketing_Alias__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Phone__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Prefilled__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Primary_Source__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_SIC__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_State__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Street_Address__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Sub_Industry__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_URL__c": {
    "type": "string",
    "maxLength": 255
  },
  "Demandbase_Zip__c": {
    "type": "string",
    "maxLength": 255
  },
  "Direct_Mail_OK__c": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(oneMktoFieldValueMap.Direct_Mail_OK__c))
  },
  "Email_Blast_OK__c": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(oneMktoFieldValueMap.Direct_Mail_OK__c)),
    "error": "'Email_Blast_OK__c' must be 'Yes' or 'No'."
  },
  "FirstName_Localized__c": {
    "type": "string",
    "maxLength": 40
  },
  "GAClientID": {
    "type": "string",
    "maxLength": 255
  },
  "GCLID": {
    "type": "string",
    "maxLength": 255
  },
  "Industry_Self_Reported__c": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(oneMktoFieldValueMap.Industry_Self_Reported__c)),
    "error": "'${/Industry_Self_Reported__c}' is not a valid 'Industry_Self_Reported__c'."
  },
  "InteractionStage": {
    "type": "string",
    "enum": ["1", "2"],
    "error": "'InteractionStage' must be 1 or 2."
  },
  "Job_Title__c": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(oneMktoFieldValueMap.Job_Title__c)),
    "error": "'${/Job_Title__c}' is not a valid 'Job_Title__c'."
  },
  "LastName_Localized__c": {
    "type": "string",
    "maxLength": 80
  },
  "MailingCity_Localized__c": {
    "type": "string",
    "maxLength": 80
  },
  "MailingCountry_Localized__c": {
    "type": "string",
    "maxLength": 80
  },
  "MailingPostal_Localized_C__c": {
    "type": "string",
    "maxLength": 10
  },
  "MailingState_Localized__c": {
    "type": "string",
    "maxLength": 20
  },
  "MailingStreet_Localized__c": {
    "type": "string",
    "maxLength": 2000
  },
  "Company_Localized__c": {
    "type": "string",
    "maxLength": 80
  },
  "NumberOfEmployees_Self_Reported__c": {
    "type": "string",
    "pattern": _Patterns.default.NUMBER_OF_EMPLOYEES_GLOBAL,
    "error": "${/NumberOfEmployees_Self_Reported__c} is not a valid 'NumberOfEmployees_Self_Reported__c'."
  },
  "OK_to_Call__c": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(oneMktoFieldValueMap.OK_to_Call__c)),
    "error": "'OK_to_Call__c' must be 'Yes' or 'No'."
  },
  "Partnerid": {
    "type": "string",
    "pattern": "^\\s*$",
    "error": "'Partnerid' should not be present for this type ${/Record_Processing_Type__c}."
  },
  "Preferred_Language__c": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(oneMktoFieldValueMap.Preferred_Language__c)),
    "error": "'${/Preferred_Language__c}' is not a valid 'Preferred_Language__c'."
  },
  "Privacy": {
    "type": "string",
    "maxLength": 3
  },
  "Project_Budget__c": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(oneMktoFieldValueMap.Project_Budget__c)),
    "error": "'${/Project_Budget__c}' is not a valid 'Project_Budget__c'."
  },
  "Purchase_Timeframe__c": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(oneMktoFieldValueMap.Purchase_Timeframe__c)),
    "error": "'${/Purchase_Timeframe__c}' is not a valid 'Purchase_Timeframe__c'."
  },
  "Question_1__c": {
    "type": "string",
    "maxLength": 255
  },
  "Question_2__c": {
    "type": "string",
    "maxLength": 255
  },
  "Question_3__c": {
    "type": "string",
    "maxLength": 255
  },
  "Question_4__c": {
    "type": "string",
    "maxLength": 255
  },
  "Question_5__c": {
    "type": "string",
    "maxLength": 255
  },
  "Record_Processing_Type__c": {
    "type": "string",
    "enum": oneMktoFieldValueMap.Record_Processing_Type__c,
    "error": "'${/ctx_RecordProcessingType}' is not a valid 'Record_Processing_Type__c'."
  },
  "Registration_Date__c": {
    "type": "string",
    "pattern": _Patterns.default.DATE,
    "error": "Registration_Date__c is either in not in YYYY-mm-dd format, or older than 2010"
  },
  "Sales_Contact_Requested__c": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(oneMktoFieldValueMap.Sales_Contact_Requested__c)),
    "error": "'Sales_Contact_Requested__c' must be 'Yes' or 'No'."
  },
  "UTM_Campaign_Number__c": {
    "type": "string",
    "maxLength": 80
  },
  "UTM_Campaign__c": {
    "type": "string",
    "maxLength": 80
  },
  "UTM_Content__c": {
    "type": "string",
    "maxLength": 80
  },
  "UTM_Domain__c": {
    "type": "string",
    "maxLength": 80
  },
  "UTM_Last_Campaign_Session__c": {
    "type": "string",
    "maxLength": 80
  },
  "UTM_Medium__c": {
    "type": "string",
    "maxLength": 80
  },
  "UTM_Program_Code__c": {
    "type": "string",
    "maxLength": 80
  },
  "UTM_Referral_Sources__c": {
    "type": "string",
    "maxLength": 2000
  },
  "UTM_Session_Date__c": {
    "type": "string",
    "pattern": "^$|" + _Patterns.default.DATE,
    "error": "UTM_Session_Date__c is either in not in YYYY-mm-dd format, or older than 2010"
  },
  "UTM_Session__c": {
    "type": "string",
    "maxLength": 80
  },
  "UTM_Source__c": {
    "type": "string",
    "maxLength": 80
  },
  "UTM_Term__c": {
    "type": "string",
    "maxLength": 80
  },
  "address": {
    "type": "string",
    "maxLength": 2000
  },
  "city": {
    "type": "string",
    "maxLength": 40
  },
  "department": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(oneMktoFieldValueMap.department)),
    "error": "'${/department}' is not a valid 'department'."
  },
  "email": {
    "type": "string",
    "pattern": _Patterns.default.EMAIL,
    "error": "${/email} does not appear to be a valid email address."
  },
  "firstName": {
    "type": "string",
    "maxLength": 40
  },
  "lastName": {
    "type": "string",
    "maxLength": 80
  },
  "leadStatus": {
    "type": "string",
    "enum": ["A", "B", "I"],
    "error": "'leadStatus' must be 'A', 'B' or 'I'."
  },
  "lookupField": {
    "type": "string",
    "error": "'lookupField' must be 'email'.",
    "enum": ["email"]
  },
  "mobilePhone": {
    "type": "string",
    "pattern": _Patterns.default.PHONE,
    "error": "'mobilePhone' does not appear to be a valid phone format ${/mobilePhone}."
  },
  "phone": {
    "type": "string",
    "pattern": _Patterns.default.PHONE,
    "error": "'phone' does not appear to be a valid phone format ${/phone}."
  },
  "postalCode": {
    "type": "string",
    "maxLength": 10
  },
  "programName": {
    "type": "string",
    "pattern": _Patterns.default.ONE_MKTO_PROGRAM_NAME,
    "error": "'programName' must less than 80 characters."
  },
  "reason": {
    "type": "string",
    "error": "'reason' must be 'Manual Import or Remote POST'.",
    "enum": ["Manual Import or Remote POST"]
  },
  "salutation": {
    "type": "string",
    "enum": [""].concat(_toConsumableArray(oneMktoFieldValueMap.salutation)),
    "error": "'${/salutation}' is not a valid 'salutation'."
  },
  "source": {
    "type": "string",
    "pattern": _Patterns.default.SOURCE,
    "error": "'source' should follow this pattern 'MarTel Slug: [slug]'"
  },
  "state": {
    "type": "string",
    "maxLength": 20
  },
  "title": {
    "type": "string",
    "maxLength": 60
  },
  "marketingSuspended": {
    "type": "string",
    "pattern": _Patterns.default.TRUE_OR_FALSE,
    "error": "${/marketingSuspended} is not a valid 'marketingSuspended'."
  }
};

var SCHEMA_PROPS = function SCHEMA_PROPS() {
  var mkto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "legacy";
  return mkto === "legacy" ? legacy : oneMkto;
};

var _default = SCHEMA_PROPS;
exports.default = _default;
//# sourceMappingURL=SchemaProps.js.map